import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThinLongRight = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m18.5 15.5 3.5-3.5-3.5-3.5-.707.707 2.293 2.293h-18.086v1h18.086l-2.293 2.293z",
		fill: "#2e3a59"
	})
});
export { SvgThinLongRight as ReactComponent };
